import React from 'react';
import { XCircleIcon } from '@heroicons/react/outline';

export interface Props {
  title: string;
  cards: JSX.Element[] | undefined;
  onSelect: (data: any) => void;
  onClose: () => void;
}

export function CardPanel(props: Props) {
  const { title, cards, onSelect, onClose } = props;
  return (
    <div className="fixed z-20 grid h-screen w-screen items-center justify-center">
      <div className="absolute z-0 h-full w-full bg-black opacity-30 blur" />
      <div className="z-40 w-[42rem] rounded rounded-t bg-white">
        <header className="relative flex h-10 items-center justify-between rounded-t bg-gray-600">
          <label className="mx-4 text-lg font-bold text-white">{title}</label>
          <XCircleIcon
            className="mx-3 h-7 w-7 cursor-pointer text-white"
            onClick={onClose}
          />
        </header>
        <div className="grid max-h-[calc(65vh)] grid-cols-card justify-center gap-10 overflow-y-auto pt-8 pb-10">
          {cards}
        </div>
      </div>
    </div>
  );
}
